import React from 'react'
import PropTypes from 'prop-types'

/**
 * Displays a selected component according to the given map of components.
 */
const ComponentSwitch = ({ components, selected, ...props }) => {
  const Component = components[selected]
  return Component ? <Component {...props} /> : null
}

ComponentSwitch.defaultProps = {
  components: {},
}

ComponentSwitch.propTypes = {
  /**
   * A key/value object representing a map of components as name/function.
   */
  components: PropTypes.object,
  /**
   * The currently selected component name to display.
   */
  selected: PropTypes.string,
}

export default ComponentSwitch
